import { setDashboardViewF } from './setDashboardViewF'
import { setTaskHistoryF } from './setTaskHistoryF'

export const setFlows = [setDashboardViewF, setTaskHistoryF]
